/**
 * Export all experiment translations
 * Last updated: 2025-08-14
 * Updated by: JulianPolly
 */

import { bandwagon } from './bandwagon';
import { M1InfoScreen } from './M1InfoScreen';
import { attributeFraming } from './AttributeFraming';
import { mentalAccounting } from './MentalAccounting';
import { LGFraming } from './LGFraming';
import { RiskyChoiceFraming } from './RiskyChoiceFraming';
import { Ultimatum } from './Ultimatum';
import { DecoyEffect } from './DecoyEffect';
import { DefaultOption } from './Default';
import { nudge } from './Nudge';
import { EndowmentEffect } from './EndowmentEffect';


export const experiments = {
    bandwagon,
    M1InfoScreen,
    attributeFraming,
    mentalAccounting,
    LGFraming,
    RiskyChoiceFraming,
    Ultimatum,
    DecoyEffect,
    DefaultOption,
    nudge,
    EndowmentEffect,

};